@import '../../style/index';

$margin-between-elements: var(--spacings-l) 0 0;
$margin-between-elements-medium-up: var(--spacings-l) 0 0;
$margin-between-list-items: rem-calc(8px) 0 0;
$padding-left-list-item: rem-calc(20px);
$padding-list-item: 0 0 0 $padding-left-list-item;
$bullet-size: 7px;

.wrapper {
  display: block;

  @include component-margin();
}

.wrapper-highlight-box {
  display: block;
  margin: calc(var(--spacings-xl) + var(--spacings-l)) 0 var(--spacings-l) 0;
}

.richtext {
  @include no-shadow;

  ol,
  ul {
    position: relative;
    display: block;
  }

  p {
    position: relative;
    @include layer-normal-top;
  }

  &--1 {
    @include copy-primary;
    margin: unset;
  }

  &--2 {
    @include copy-secondary;
    margin: unset;
  }

  &--3 {
    @include copy-footnotes;
    margin: unset;
  }

  &--width {
    &--medium {
      padding: 0 rem-calc(16px);

      @include medium-up {
        padding: 0;
      }

      @include large-up {
        padding: 0 rem-calc(48px);
      }
    }
  }

  h2 {
    color: var(--colors-dark-base);
    display: block;
    position: relative;
    z-index: 5;
  }

  h3 {
    color: var(--colors-dark-base);
    display: block;
    position: relative;
    z-index: 5;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  > * {
    margin: $margin-between-elements;
    padding: 0;

    @include medium-up {
      margin: $margin-between-elements-medium-up;
    }

    &:first-child {
      margin: 0;
    }
  }

  &[right-to-left] {
    * {
      direction: rtl;
    }
  }

  ul > li,
  ol > li {
    display: block;
    margin: $margin-between-list-items;
    padding: $padding-list-item;
    position: relative;
  }

  ol {
    counter-reset: item;
    padding: $padding-list-item;

    li {
      counter-increment: item;
      padding: 0 0 0 rem-calc(10px);

      &::before {
        content: counter(item) '.';
        position: absolute;
        left: -#{$padding-left-list-item};
        z-index: 5;
      }
    }
  }

  ul {
    list-style: none;

    li {
      &::before {
        content: '-';
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 5;
      }
    }
  }

  rcm-icon {
    display: inline-block;
  }

  blockquote {
    p {
      margin: 0 2rem;
      font-family: $font-family-semibolditalic;
    }
  }

  .superscript {
    vertical-align: super;
    font-size: 80%;
  }

  .subscript {
    vertical-align: sub;
    font-size: 80%;
  }

  .box-grey-base,
  .box-grey-dark,
  .box-grey-md,
  .box-grey-light {
    &::after {
      background-color: var(--colors-grey-background);
      height: 100%;
      width: calc(100% + var(--highlightbox-left) * 2);
      content: ' ';
      position: absolute;
      top: rem-calc(-16px);
      left: calc(0px - var(--highlightbox-left));
      right: var(--highlightbox-right);
      padding: rem-calc(16px) 0;
      z-index: -1;
    }
  }

  .box-grey-dark::after {
    background-color: var(--colors-grey-base);
  }

  .box-grey-md::after {
    background-color: var(--colors-grey-medium);
  }

  .box-grey-light::after {
    background-color: var(--colors-grey-light);
  }

  .box-grey--article::after {
    width: calc(100% + rem-calc(32px) * 2);
    left: calc(0px - rem-calc(32px));
    right: rem-calc(32px);

    @include large-up() {
      width: calc(100% + rem-calc(48px) * 2);
      left: calc(0px - rem-calc(48px));
      right: rem-calc(48px);
    }

    @include xlarge-up() {
      width: calc(100% + rem-calc(112px) * 2);
      left: calc(0px - rem-calc(112px));
      right: rem-calc(112px);
    }
  }

  rcm-headline {
    margin-top: rem-calc(32px);
  }

  b {
    font-weight: normal;
    font-family: $font-family-semibold;
  }

  a {
    @include link-richtext();
  }
}

.margin-0 {
  margin: 0;
}

.box-grey-base,
.box-grey-dark,
.box-grey-md,
.box-grey-light {
  &::after {
    background-color: var(--colors-grey-background);
    height: 100%;
    width: calc(100% + var(--highlightbox-left) * 2);
    content: ' ';
    position: absolute;
    top: calc(0px - var(--spacings-l));
    left: calc(0px - var(--highlightbox-left));
    right: var(--highlightbox-right);
    padding: var(--spacings-l) 0;
    z-index: 1;
  }
}

.box-grey-dark::after {
  background-color: var(--colors-grey-base);
}

.box-grey-md::after {
  background-color: var(--colors-grey-medium);
}

.box-grey-light::after {
  background-color: var(--colors-grey-light);
}

.box-grey--article::after {
  width: calc(100% + rem-calc(32px) * 2);
  left: calc(0px - rem-calc(32px));
  right: rem-calc(32px);

  @include large-up() {
    width: calc(100% + rem-calc(48px) * 2);
    left: calc(0px - rem-calc(48px));
    right: rem-calc(48px);
  }

  @include xlarge-up() {
    width: calc(100% + rem-calc(112px) * 2);
    left: calc(0px - rem-calc(112px));
    right: rem-calc(112px);
  }
}
